import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardActions,
  CardContent,
  TablePagination,
} from "@material-ui/core";

import Action from "../Action/Action";
import TablePaginationActions from "./TablePaginationActions";
import CustomTable from "./CustomTable";

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 1050,
    [theme.breakpoints.down("xs")]: {
      minWidth: 50,
    },
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  actions: {
    justifyContent: "flex-end",
  },
  hidden: {
    display: "none",
  },
}));

const Table = (props) => {
  const {
    className,
    data,
    deleteItem,
    columns,
    handleSortChange,
    sort,
    ActionDeleteMany,
    rowsPerPage,
    handleRowsPerPageChange,
    tableService,
    pageLink,
    noShow,
    noDelete,
    noEdit,
    replace,
    noAction,
    initializeData,
    offerAction,
    noPagination,
    noCheck,
    deleteUrl,
    keyValue,
    loading,
    handlePageChange,
    page,
    otherFunction,
    ...rest
  } = props;
  const classes = useStyles();

  // const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <CustomTable
              columns={columns}
              deleteItem={deleteItem}
              otherFunction={otherFunction}
              data={data}
              sort={sort}
              handleSortChange={handleSortChange}
              ActionComponent={Action}
              tableService={tableService}
              pageLink={pageLink}
              noShow={noShow}
              offerAction={offerAction}
              noDelete={noDelete}
              noEdit={noEdit}
              noAction={noAction}
              noCheck={noCheck}
              replace={replace}
              initializeData={initializeData}
              deleteUrl={deleteUrl}
              keyValue={keyValue}
              loading={loading}
            />
          </div>
        </PerfectScrollbar>
      </CardContent>
      {/* {!noPagination && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={500}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )} */}
    </Card>
  );
};

Table.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.array,
  handleSortChange: PropTypes.func,
  sort: PropTypes.object,
  handlePageChange: PropTypes.func,
  page: PropTypes.number,
  deleteUrl: PropTypes.string,
  delete: PropTypes.func,
};

export default Table;
